import ScopeRuleRow from "./ScopeRuleRow";

export default function ScopeRulesTable({ rules, onChange }) {
  const updateRule = (index, updated) => {
    const next = [...rules];
    next[index] = updated;
    onChange(next);
  };

  const removeRule = (index) => {
    onChange(rules.filter((_, i) => i !== index));
  };

  const addRule = () => {
    onChange([...rules, { method: "GET", scope: "", block: false }]);
  };

  return (
    <>
      <label className="form-label mb-2 d-block">Scope Rules</label>

      {rules && rules.length > 0 && (
        <table className="tabledd table-sm p-0 text-xs">
          <colgroup>
            <col style={{ width: "28%" }} />
            <col style={{ width: "47%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <thead className="text-secondary text-xxs">
            <tr>
              <th>Method</th>
              <th>Scope</th>
              <th className="text-center">Block</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rules.map((rule, index) => (
              <ScopeRuleRow
                key={rule.id || index}
                rule={rule}
                onChange={(updated) => updateRule(index, updated)}
                onDelete={() => removeRule(index)}
              />
            ))}
          </tbody>
        </table>
      )}

      <button
        className={`btn btn-sm btn-info py-1 text-xxs ${rules.length > 0 ? "my-3":"mb-3"}`}
        onClick={addRule}
      >
        + Add Scope Rule
      </button>
    </>
  );
}
